<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toccn" id="copy_1"><span href="#/Girls_copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toccn" id="chap_1"><a href="#/Girls_chap_1">Ruby &amp; Me</a></p>
<p class="toccn" id="chap_2"><a href="#/Girls_chap_2">Mother’s Nature</a></p>
<p class="toccn" id="chap_3"><a href="#/Girls_chap_3">Nature’s Mother</a></p>
<p class="toccn" id="chap_4"><span href="#/Girls_chap_4" title="Link target outside of Sample">Country Mice</span></p>
<p class="toccn" id="chap_5"><span href="#/Girls_chap_5" title="Link target outside of Sample">Writing &amp; Deadlines</span></p>
<p class="toccn" id="chap_6"><span href="#/Girls_chap_6" title="Link target outside of Sample">Holy Ghosts</span></p>
<p class="toccn" id="chap_8"><span href="#/Girls_chap_8" title="Link target outside of Sample">Birds &amp; Feathers</span></p>
<p class="toccn" id="chap_9"><span href="#/Girls_chap_9" title="Link target outside of Sample">Coots</span></p>
<p class="toccn" id="chap_11"><span href="#/Girls_chap_11" title="Link target outside of Sample">The Secret Life of Crows</span></p>
<p class="toccn" id="chap_12"><span href="#/Girls_chap_12" title="Link target outside of Sample">Heaven’s Door</span></p>
<p class="toccn" id="chap_13"><span href="#/Girls_chap_13" title="Link target outside of Sample">Mysterious Ways</span></p>
<p class="toccn" id="chap_15"><span href="#/Girls_chap_15" title="Link target outside of Sample">You</span></p>
<p class="toccn" id="chap_17"><span href="#/Girls_chap_17" title="Link target outside of Sample">La Tranche</span></p>
<p class="toccn" id="chap_18"><span href="#/Girls_chap_18" title="Link target outside of Sample">Concentric Circles</span></p>
<p class="toccn" id="chap_20"><span href="#/Girls_chap_20" title="Link target outside of Sample">Summer</span></p>
<p class="toccn" id="chap_21"><span href="#/Girls_chap_21" title="Link target outside of Sample">The Story of the Wedding Dress</span></p>
<p class="toccn" id="chap_22"><span href="#/Girls_chap_22" title="Link target outside of Sample">Remains</span></p>
<p class="toccn" id="chap_23"><span href="#/Girls_chap_23" title="Link target outside of Sample">The surprise party was amazing! Happy Birthday to us!</span></p>
<p class="toccn" id="chap_24"><span href="#/Girls_chap_24" title="Link target outside of Sample">Peevo</span></p>
<p class="toccn" id="chap_25"><span href="#/Girls_chap_25" title="Link target outside of Sample">Deadlines &amp; Writing</span></p>
<p class="toccn" id="chap_26"><span href="#/Girls_chap_26" title="Link target outside of Sample">Premonitions &amp; Portents</span></p>
<p class="toccn" id="chap_28"><span href="#/Girls_chap_28" title="Link target outside of Sample">Writing</span></p>
<p class="toccn" id="chap_30"><span href="#/Girls_chap_30" title="Link target outside of Sample">Prosim</span></p>
<p class="toccn" id="chap_32"><span href="#/Girls_chap_32" title="Link target outside of Sample">Home Again, Home Again</span></p>
<p class="toccn" id="chap_34"><span href="#/Girls_chap_34" title="Link target outside of Sample">Writers and Baseball</span></p>
<p class="toccn" id="chap_35"><span href="#/Girls_chap_35" title="Link target outside of Sample">Human Conditions</span></p>
<p class="toccn" id="chap_37"><span href="#/Girls_chap_37" title="Link target outside of Sample">Love Poems</span></p>
<p class="toccn" id="chap_38"><span href="#/Girls_chap_38" title="Link target outside of Sample">Dead Men’s Ember</span></p>
<p class="toccn" id="chap_40"><span href="#/Girls_chap_40" title="Link target outside of Sample">Writers &amp; Readers</span></p>
<p class="toccn" id="ackn_1"><span href="#/Girls_ackn_1" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toccn" id="auth_bio_1"><span href="#/Girls_auth_bio_1" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Girls_toc.vue?9e8eb030